import { useQuery } from '@tanstack/react-query';
import { DataExportSchemaConfigListItem } from '../types';

export const DATA_EXPORT_SCHEMA_CONFIGS_KEY = ['data-export-configs'];

export default function useDataExportSchemaConfigs() {
  return useQuery<DataExportSchemaConfigListItem[]>({
    queryKey: DATA_EXPORT_SCHEMA_CONFIGS_KEY,
  });
}
